import c from "../common";

export default {
  title: "Advertisement",
  text1: "",
  text2: "Title",
  text3: "visible",
  text4: "hidden",
  text5: "Description",
  text6: "Link",
  text7: "Please provide title",
  text8: "Please provide cover photo",
  text9: "select ad to view detail",
  text10: "Detail",
  text11: "Create",
  text12: "Undo changes",
  text13: "Save",
  text14: "Are you sure you want to delete this ad? This action cannot be undone",
  text15: "Delete",
  text16: "Title (required)",
  text17: "Time",
  text18: "clear time",
  text19: "cancel change?",
  text20: "Back",
  text21: "Cover Photo (required)",
  text22: "Whether the ad is visible",
  text23: "Cover Photo",
  text24: "Related Shop",
  text25: "Add Photo",
  text26: "The upper limit of 4 is reached",
  text27: "Up to 4 photo",
  text28: "Search shop name",
  text29: "Create Success",
  text30: "Deleted",
  text31: "Update Success",
};
